import React from 'react';
import {PropTypes} from 'prop-types';
import {matchPath, withRouter} from 'react-router-dom';

import UnifiedApp from './app';
import {
  expandedLayoutPath,
  EVENT_PATH,
  HIDEMERCHHEADER_PATH,
  HIDEFOOTER_PATH,
  SELLTICKET_PATH,
  HIDEMERCHHEADER_EXCEPTIONS,
  HIDE_GOOGLE_SEM_MESSAGE_PATH,
} from './path';

/**
 * A UnifiedApp wrapper component that will check page URL path to decide whether to use
 * `expanded` search bar style.
 * @param {Object} props - Props object set to Unified App
 */
export function UnifiedLayout(props) {
  const {currentLocale, defaultLocale, location} = props;

  const lang = currentLocale !== defaultLocale ? currentLocale.substr(0, 2) : '';
  const langPath = lang ? `/${lang}` : '';
  // Though below has code duplicates, it makes the layout responds to URL path irrelative to page content rendering
  const expandedLayoutPaths = expandedLayoutPath(langPath);

  const searchBarStyle = expandedLayoutPaths.some((p) => matchPath(location.pathname, p)) ? 'expanded' : 'modal';

  // Here if event or checkout path then showMerchHeaderFooter = false
  const showMerchHeaderFooter = !HIDEFOOTER_PATH.some((p) => matchPath(location.pathname, p));

  let showEventMerchHeader = false;

  if (!showMerchHeaderFooter && matchPath(location.pathname, EVENT_PATH)) {
    showEventMerchHeader = true;
  }

  const hideMerchHeaderException = HIDEMERCHHEADER_EXCEPTIONS.some((path) => matchPath(location.pathname, path));
  const showMerchHeader =
    hideMerchHeaderException || !HIDEMERCHHEADER_PATH.some((p) => matchPath(location.pathname, p));

  const showSellTicketHeader = matchPath(location.pathname, SELLTICKET_PATH);

  const showGoogleSemMessage = !HIDE_GOOGLE_SEM_MESSAGE_PATH.some((p) => {
    return matchPath(location.pathname, p);
  });

  return (
    <UnifiedApp
      searchBarStyle={searchBarStyle}
      showFooter={showMerchHeaderFooter}
      showEventMerchHeader={showEventMerchHeader}
      showMerchHeader={showMerchHeader}
      showSellTicketHeader={showSellTicketHeader}
      showGoogleSemMessage={showGoogleSemMessage}
      {...props}
    />
  );
}

UnifiedLayout.propTypes = {
  /** Current locale */
  currentLocale: PropTypes.string,

  /** Default site locale */
  defaultLocale: PropTypes.string,

  /** Location object */
  location: PropTypes.object,
};

export default withRouter(UnifiedLayout);
